import { LocalStorageKey } from "src/core/local-storage/local-storage.model";
import { useLocalStorage } from "src/core/local-storage/hooks/useLocalStorage";

export function useSessionToken() {
    return useLocalStorage<string | null>(LocalStorageKey.SessionToken, null);
}